import "./ressources.scss"
import React, { useEffect, useState } from 'react'
import { GridColDef } from "@mui/x-data-grid";
import DataTable from '../../components/dataTable/DataTable.tsx'
import Add from '../../components/add/Add.tsx';
import axios from "axios"
import { useQuery } from "@tanstack/react-query";

const columns: GridColDef[] = [
  { field: '_id', headerName: 'ID', width: 50, },
  {
    field: 'userAvatar', headerName: "Avatar", width: 60,
    renderCell: (params) => {
      return <img src={params.row.img || "/noavatar.png"} alt="" />
    }
  },
  { field: 'name', headerName: "Name", width: 150 },
  { field: 'itsi', headerName: "Kennung", width: 90 },
  { field: 'type', headerName: "Typ", width: 90 },
  { field: 'organization', headerName: "Organisation", width: 200 },
];

const Ressources = () => {
  const [ressources, setRessources] = useState([])
  const [open, setOpen] = useState(false)
  const { isLoading, error, data } = useQuery({
    queryKey: ["allRessources"],
    queryFn: () =>
      fetch("/api/ressources").then(
        (res) => res.json()
      ),
  });
/*  const fetchRessoruces = async () => {
    try {
      const res = await axios.get("/api/ressources");
      setRessources(res.data);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchRessoruces();
  }, [])*/

  return (
    <div className="ressources">
      <div className="info">
        <h1>Einsatzmittel</h1>
        <button onClick={() => setOpen(true)}>Neues Einsatzmittel anlegen</button>
      </div>
      {isLoading ? (
        "Lade..."
      ) : (
        <DataTable header="Einsatzmittel" slug="ressources" columns={columns} rows={data} />
      )}
      {open && <Add header="Neues Einsatzmittel hinzufügen" slug='ressource' columns={columns} setOpen={setOpen} />}

    </div>
  )
}

export default Ressources